module.exports = __webpack_public_path__ + "static/media/36.1b74cae2.JPG";